class BuilderResultsTemplate {
	constructor(el) {
		this.el = el;
		this.storedValue = sessionStorage.getItem('formData');
		this.printButton = this.el.querySelector('.tmpl-builder-results__print-btn');

		this.updateField();
		this.printPage();
	}

	updateField = () => {
		const parsedValue = JSON.parse(this.storedValue);
		if (this.storedValue !== null) {
			let results = '';
			Object.entries(parsedValue).forEach(([key, value]) => {
				if (Array.isArray(value)) {
					value.forEach((element, index) => {
						results += `${key} ${index + 1}: ${element}\n`;
					});
				} else {
					results += `${key}: ${value}\n`;
				}
			});
			const textArea = document.getElementById('input_1_6');
			if (textArea !== null) {
				textArea.value = results;
			}
		} else {
			console.log('Key not found in session storage.');
		}
	};

	printPage = () => {
		this.printButton.addEventListener('click', (e) => {
			e.preventDefault();
			window.print();
		});
	};
}

export default BuilderResultsTemplate;
